/**
 * Pre-configured dayjs instance with common plugins.
 *
 * This exports a dayjs instance with the following plugins enabled:
 * - relativeTime: for time calculations like "3 hours ago"
 * - duration: for handling time spans and durations
 * - utc: for UTC time handling
 * - localizedFormat: for locale-ordered formats like 'LL'
 *
 * @module dayjs
 */

import dayjs from 'dayjs'
import durationPlugin from 'dayjs/plugin/duration'
import utcPlugin from 'dayjs/plugin/utc'
import relativeTimePlugin from 'dayjs/plugin/relativeTime'
import isBetween from 'dayjs/plugin/isBetween'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(relativeTimePlugin)
dayjs.extend(durationPlugin)
dayjs.extend(utcPlugin)
dayjs.extend(isBetween)
dayjs.extend(localizedFormat)

export default dayjs
